<div class="options-chain-header">
    <span>Expirations</span>
</div>
<div class="expiry-list">
    <div class="expiry-group">
        <button class="btn-expiry" *ngFor="let expiry of expiries" [class.active]="expiry === selectedExpiry"
            (click)="selectExpiry(expiry)">
            {{ expiry | date:'dd MMM yy' }} <!-- Formatting assuming timestamp -->
        </button>
        <div *ngIf="expiries.length === 0" style="padding: 10px; color: #848e9c; font-size: 12px;">
            No Expiries
        </div>
    </div>
</div>